export default __webpack_public_path__ + "static/media/stackoverflow.585c6b84.svg";